import { z } from 'zod';

export enum CREATE_ORGANIZATION_FORM {
	NAME = 'name',
	OWNER_EMAIL = 'ownerEmail',
	CONTACT_EMAIL = 'contactEmail',
	EMAIL_DOMAINS = 'emailDomains',
}

export const CreateOrganizationShape = () =>
	z.object({
		[CREATE_ORGANIZATION_FORM.NAME]: z.string().trim().min(1, 'Required'),
		[CREATE_ORGANIZATION_FORM.OWNER_EMAIL]: z.string().trim().email(),
		[CREATE_ORGANIZATION_FORM.CONTACT_EMAIL]: z
			.string()
			.trim()
			.email()
			.optional()
			.or(z.literal('')),
		[CREATE_ORGANIZATION_FORM.EMAIL_DOMAINS]: z.string().optional().or(z.literal('')),
	});

export type CreateOrganizationFormValues = z.infer<ReturnType<typeof CreateOrganizationShape>>;
